var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_54eaf879"]},_vm.$listeners),[_c('mpx-rich-text',{class:["cube-nav-item-inner"],attrs:{"nodes":(_vm.txt)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }